import { render, staticRenderFns } from "./SectionTaxInvoice.vue?vue&type=template&id=f9ce2f40&scoped=true&"
import script from "./SectionTaxInvoice.vue?vue&type=script&lang=ts&"
export * from "./SectionTaxInvoice.vue?vue&type=script&lang=ts&"
import style0 from "./SectionTaxInvoice.vue?vue&type=style&index=0&id=f9ce2f40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ce2f40",
  null
  
)

export default component.exports